// extracted by mini-css-extract-plugin
export default {"layout":"Index_layout__qTSyV","hasMaxWidth":"Index_hasMaxWidth__+dsC3","header":"Index_header__cDV7u"};